import React, { useState, useEffect, useRef } from 'react';
import AuthUser from '../../../pageauth/AuthUser';
import PuenteApi from '../../../pageauth/PuenteApi';
import Mensaje from '../../../Mensaje';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Cargando from '../../../Cargando';
import CryptoJS from "crypto-js";

export const CuerpoHomeRemoteWork = () => {
    require('./Remotework.css?v=1.1.0');
    const navigate = useNavigate();
    const { SetMensaje } = Mensaje();
    const { StartCargando, StopCargando } = Cargando()
    const { CerrarSession, ObtenerEstaciones } = PuenteApi()
    const { getModule, getModuleSector, getApodoSector } = AuthUser()
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

    useEffect(() => {
        const estacionesGuardadas = localStorage.getItem("estaciones");

        if (estacionesGuardadas) {
        } else {
            obtenerEstaciones();
        }
    }, []);

    const obtenerEstaciones = async () => {
        try {
            const response = await ObtenerEstaciones();
            if (response) {
                localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());
            }
        } catch (error) {
            console.error("Error al obtener estaciones:", error);
        }
    };

    return (
        <div>
            <div class="container-fluid py-4">
                <div class="row">

                    <div class="col-lg-6 col-12 mt-4 mt-lg-0">
                        <div class="card shadow h-100">
                            <div class="card-header pb-0 p-3">
                                <h6 class="mb-0">Reviews</h6>
                            </div>
                            <div class="card-body pb-0 p-3">
                                <ul class="list-group">
                                    <li class="list-group-item border-0 d-flex align-items-center px-0 mb-0">
                                        <div class="w-100">
                                            <div class="d-flex mb-2">
                                                <span class="me-2 text-sm font-weight-bold text-dark">Positive Reviews</span>
                                                <span class="ms-auto text-sm font-weight-bold">80%</span>
                                            </div>
                                            <div>
                                                <div class="progress progress-md">
                                                    <div class="progress-bar bg-primary w-80" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item border-0 d-flex align-items-center px-0 mb-2">
                                        <div class="w-100">
                                            <div class="d-flex mb-2">
                                                <span class="me-2 text-sm font-weight-bold text-dark">Neutral Reviews</span>
                                                <span class="ms-auto text-sm font-weight-bold">17%</span>
                                            </div>
                                            <div>
                                                <div class="progress progress-md">
                                                    <div class="progress-bar bg-primary w-10" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item border-0 d-flex align-items-center px-0 mb-2">
                                        <div class="w-100">
                                            <div class="d-flex mb-2">
                                                <span class="me-2 text-sm font-weight-bold text-dark">Negative Reviews</span>
                                                <span class="ms-auto text-sm font-weight-bold">3%</span>
                                            </div>
                                            <div>
                                                <div class="progress progress-md">
                                                    <div class="progress-bar bg-primary w-5" role="progressbar" aria-valuenow="5" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="card-footer pt-0 p-3 d-flex align-items-center">
                                <div class="w-60">
                                    <p class="text-sm">
                                        More than <b>1,500,000</b> developers used Creative Tim's products and over <b>700,000</b> projects were created.
                                    </p>
                                </div>
                                <div class="w-40 text-end">
                                    <a class="btn btn-dark mb-0 text-end" href="javascript:;">View all reviews</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">

                    <div class="col-lg-7">
                        <div class="card z-index-2">
                            <div class="card-header pb-0">
                                <h6>Sales overview</h6>
                                <p class="text-sm">
                                    <i class="fa fa-arrow-up text-success"></i>
                                    <span class="font-weight-bold">4% more</span> in 2021
                                </p>
                            </div>
                            <div class="card-body p-3">
                                <div class="chart">
                                    <canvas id="chart-line" class="chart-canvas" height="300"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}